module.exports = __webpack_public_path__ + "img/minus-red-indicator.e7287b60.svg";